import { Box, TextField } from '@mui/material';
import Typography from '../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { useTextFieldWithMaxLength } from './hooks/useTextFieldWithMaxLength';
import { TextFieldWithMaxLengthProps } from './textFieldWithMaxLength.types';

const TextFieldWithMaxLength = ({
  label,
  value,
  onChange,
  className,
  maxLength,
  ...props
}: TextFieldWithMaxLengthProps) => {
  const { translate } = useTranslation();

  const { handleChange } = useTextFieldWithMaxLength({
    onChange,
    maxLength,
  });

  const labelWithMaxLength = `${translate(label)} (${translate(
    LangEnum.GLOBAL_MAX_CHARACTERS_SHORT,
    {
      max: maxLength,
    },
  )})`;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
      }}
    >
      <TextField
        variant="standard"
        value={value}
        className={className}
        onChange={handleChange}
        label={labelWithMaxLength}
        {...props}
      />
      <Box
        sx={{
          alignSelf: 'flex-end',
        }}
      >
        <Typography variant="body3-regular" color="textSecondary">
          {value.length}/{maxLength}
        </Typography>
      </Box>
    </Box>
  );
};

export default TextFieldWithMaxLength;
